/* Package JSON Import will be here */
import React from "react";
import { Icon, Table, Header, Segment, Pagination, Button, Modal, Form, Search, Checkbox } from 'semantic-ui-react';
import moment from 'moment';
import MultiSelect from "react-dropdown-select";
/* Package JSON Import will be here */

/* Project Import will be here */
import Layout from "../../comman/Layout/Layout";
import TimeCardIssue from "./timeCardIssue/timeCardIssue.Container";
import TimeCardDailyDetails from "./timeCardDailyDetails/timeCardDailyDetails.Container";
import { MuiPickersUtilsProvider, KeyboardDatePicker } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import "../../comman/Layout/Layout.css";
import "./timeCard.css";
import { Constants } from "../../config/appConstants";
import NoResultFound from "../sharedComponent/noResultFound";
import AttachmentViewer from "../sharedComponent/attachmentViewer/attachmentViewer.Container";
import AttestationModal from "./AttestationModal";
/* Project Import will be here */

const TimeCardComponent = props => {
    const getAttestationIconColor = (attestationStatus) => {
        if (attestationStatus) {
            if (attestationStatus === Constants.ATTESTATION_STATUS_OVERRIDE) {
                return "#3B82F6";
            } else if (attestationStatus === Constants.ATTESTATION_STATUS_REJECTED) {
                return "#EF4444";
            } else {
                return "#22C55E";
            }
        }
    }

    const itemRenderer = ({ item, itemIndex, props, state, methods }) => (
        <div key={item[props.valueField]} onClick={() => methods.addItem(item)}>
            <div style={{ margin: "10px", display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.5rem' }}>
                <Checkbox className="selectedTable mb5" checked={methods.isSelected(item)} />
                <label style={{ paddingTop: '3px' }}>{item[props.labelField]}</label>
            </div>
        </div>
    );

    const contentRenderer = ({ props, state }) => (
        <div className="attestationDropdown d-flex items-center gap-1">
            {state.values.sort((a, b) => a.id - b.id).map(a => a.text[0]).join(' ')}
        </div>
    )

    const HeaderText = ({ text }) => {
        return (
            <span style={{ height: "40px", display: "inline-block", width: "100%" }}>
                {text}
            </span>
        )
    }

    const PROCESSED_AND_EXPORTED_STATUS_LIST = [Constants.PROCESSED_STATUS, Constants.EXPORTED_STATUS].map(a => a.toLowerCase());
    const NEW_STATUS_LIST = [Constants.NEW_STATUS].map(a => a.toLowerCase());

    return (
        <Layout>
            <Segment className="time-card stickyTimeCard header-section">
                <Header as="h3">
                    <Icon name="clock outline"></Icon>
                    <span>Timecards</span>
                </Header>
                <div className="align-right issue-date" >
                    {[Constants.SYSTEM_ADMIN_ROLE_NAME, Constants.ADMIN_ROLE_NAME].includes(props.user.roleName) &&
                        <Checkbox disabled={!props.timeCard.lastArchiveDate} className='archiveLable' checked={props.timeCard.isCheckedArchive} label='Archive' onChange={(e, value) => { props.handleArchiveCheckboxChange(value.checked) }} style={{ marginLeft: '-100px' }}></Checkbox>
                    }
                    <Button primary size="mini" disabled={!props.timeCard.isInputEnabled} onClick={props.getTimeCardDailyDetails} style={{ marginRight: '10px', color: 'black ' }}>Daily Details</Button>
                    <Button primary size="mini" disabled={!props.timeCard.isInputEnabled} onClick={props.getTimeCardIssue} style={{ color: 'black ' }}>Issues</Button>
                    {/* <Button primary size="mini" onClick={() => props.showArchiveModal(true)} style={{ color: 'black' }}>Archieve</Button> */}

                    <MuiPickersUtilsProvider utils={DateFnsUtils} >
                        <KeyboardDatePicker className="issue-field"
                            disabled={!props.timeCard.isInputEnabled}
                            placeholder="MM/dd/yyyy"
                            value={props.timeCard.selectedFromDate}
                            onChange={date => props.handleFromDateChange(date)}
                            inputProps={{ readOnly: true }}
                            format="MM/dd/yyyy"
                            inputVariant="outlined"
                            label="From"
                            {...(props.timeCard.minimumDate ? { minDate: props.timeCard.minimumDate } : {})}
                            {...(props.timeCard.maximumDate ? { maxDate: props.timeCard.maximumDate } : {})}
                        // style={{ width: '40%' }}
                        />
                    </MuiPickersUtilsProvider>
                    <MuiPickersUtilsProvider utils={DateFnsUtils} >
                        <KeyboardDatePicker
                            disabled={!props.timeCard.isInputEnabled}
                            className="issue-field"
                            placeholder="MM/dd/yyyy"
                            value={props.timeCard.selectedToDate}
                            onChange={date => props.handleToDateChange(date)}
                            inputProps={{ readOnly: true }}
                            format="MM/dd/yyyy"
                            inputVariant="outlined"
                            label="To"
                            {...(props.timeCard.minimumDate ? { minDate: props.timeCard.minimumDate } : {})}
                            {...(props.timeCard.maximumDate ? { maxDate: props.timeCard.maximumDate } : {})}
                        // style={{ width: '40%' }}
                        />
                    </MuiPickersUtilsProvider>
                </div>
            </Segment>
            <div className="tableVertical">
                <Table striped celled className="ui table">
                    <Table.Header className="header-bg">
                        <Table.Row style={{ verticalAlign: 'top' }}>
                            <Table.HeaderCell className="tableCellWidth">
                                <HeaderText text={"Payroll Note"} />
                            </Table.HeaderCell >
                            <Table.HeaderCell className="text-nowrap">
                                <HeaderText text={"Employee Number - Name"} />
                                <Search onSearchChange={props.onTimecardEmployeeSearch}
                                    placeholder={Constants.SEARCH_PLACEHOLDER} />
                            </Table.HeaderCell>
                            <Table.HeaderCell className="text-nowrap">
                                <HeaderText text={"Device Name"} />
                                <Search onSearchChange={props.onTimecardDeviceSearch}
                                    placeholder={Constants.SEARCH_PLACEHOLDER} />
                            </Table.HeaderCell>
                            <Table.HeaderCell className="tableCellWidth">
                                <HeaderText text={"Project#"} />
                                <Search className="customeHeader" onSearchChange={props.onTimecardProjectSearch}
                                    placeholder={Constants.SEARCH_PLACEHOLDER} />
                            </Table.HeaderCell>
                            <Table.HeaderCell className="tableCellWidth">
                                <HeaderText text={"Task Name"} />
                                <Search className="theader" onSearchChange={props.onTimecardTaskNameSearch}
                                    placeholder={Constants.SEARCH_PLACEHOLDER} />
                            </Table.HeaderCell>
                            <Table.HeaderCell className="tableCellWidth">
                                <HeaderText text={"Pay Code"} />
                                <Search className="customeTimeHeader" onSearchChange={props.onTimecardPayCodeSearch}
                                    placeholder={Constants.SEARCH_PLACEHOLDER} />
                            </Table.HeaderCell>
                            <Table.HeaderCell className="tableCellWidth">
                                <HeaderText text={"Total Hours"} />
                                <Search className="customeTimeHeader" onSearchChange={props.onTimecardTotalHoursSearch}
                                    placeholder={Constants.SEARCH_PLACEHOLDER} />
                            </Table.HeaderCell>
                            <Table.HeaderCell className="tableCellWidth">
                                <HeaderText text={"Start Time"} />
                                <Search className="customeTimeHeader" onSearchChange={props.onTimecardStartTimeSearch}
                                    placeholder={Constants.SEARCH_PLACEHOLDER} />
                            </Table.HeaderCell>
                            <Table.HeaderCell className="tableCellWidth">
                                <HeaderText text={"Lunch Start"} />
                                <Search className="customeTimeHeader" onSearchChange={props.onTimecardLunchStartTimeSearch}
                                    placeholder={Constants.SEARCH_PLACEHOLDER} />
                            </Table.HeaderCell>
                            <Table.HeaderCell className="tableCellWidth">
                                <HeaderText text={"Lunch End"} />
                                <Search className="customeTimeHeader" onSearchChange={props.onTimecardLunchEndTimeSearch}
                                    placeholder={Constants.SEARCH_PLACEHOLDER} />
                            </Table.HeaderCell>
                            <Table.HeaderCell className="tableCellWidth">
                                <HeaderText text={"End Time"} />
                                <Search className="customeTimeHeader" onSearchChange={props.onTimecardEndTimeSearch}
                                    placeholder={Constants.SEARCH_PLACEHOLDER} />
                            </Table.HeaderCell>
                            <Table.HeaderCell className="text-nowrap">
                                <HeaderText text={"Attestation"} />
                                <MultiSelect
                                    className="attestationDropdownStyle"
                                    style={{ marginTop: '0.5rem' }}
                                    options={props.timeCard.attestationStatus}
                                    values={props.timeCard.selectedAttestationStatus}
                                    keepSelectedInList={true}
                                    labelField="value"
                                    valueField="id"
                                    multi={true}
                                    closeOnSelect={false}
                                    searchable={false}
                                    onChange={(value) => props.onChangeAttestation(value)}
                                    onDropdownClose={() => props.searchAttesation()}
                                    itemRenderer={(item, itemIndex, props, state, methods) => itemRenderer(item, itemIndex, props, state, methods)}
                                    contentRenderer={(props, state) => contentRenderer(props, state)}
                                />
                            </Table.HeaderCell>
                            <Table.HeaderCell className="tableCellWidth">
                                <HeaderText text={"Actual Units"} />
                                <Search className="customeTimeHeader" onSearchChange={props.onTimecardActualUnitsSearch}
                                    placeholder={Constants.SEARCH_PLACEHOLDER} />
                            </Table.HeaderCell>
                            <Table.HeaderCell className="tableCellWidth">
                                <HeaderText text={"Actual Notes"} />
                            </Table.HeaderCell>
                            <Table.HeaderCell className="tableCellWidth">
                                <HeaderText text={"Work Done At Job Site"} />
                                <Search className="theader" onSearchChange={props.onTimecardWorkDoneAtJobSiteSearch}
                                    placeholder={Constants.SEARCH_PLACEHOLDER} />
                            </Table.HeaderCell>
                            <Table.HeaderCell className="tableCellWidth">
                                <HeaderText text={"Job Override"} />
                                <Search className="customeHeader" onSearchChange={props.onTimecardJobOverrideSearch}
                                    placeholder={Constants.SEARCH_PLACEHOLDER} />
                            </Table.HeaderCell>
                            <Table.HeaderCell className="tableCellWidth">
                                <HeaderText text={"Union Override"} />
                                <Search className="customeHeader" onSearchChange={props.onTimecardUnionOverrideSearch}
                                    placeholder={Constants.SEARCH_PLACEHOLDER} />
                            </Table.HeaderCell>
                            <Table.HeaderCell className="tableCellWidth">
                                <HeaderText text={"Day"} />
                                <Search className="customeHeaderDay" onSearchChange={props.onTimecardDaysSearch}
                                    placeholder={Constants.SEARCH_PLACEHOLDER} />
                            </Table.HeaderCell>
                            <Table.HeaderCell className="tableCellWidth">
                                <HeaderText text={"Exp Units"} />
                                <Search className="customeTimeHeader" onSearchChange={props.onTimecardExpectationunitsSearch}
                                    placeholder={Constants.SEARCH_PLACEHOLDER} />
                            </Table.HeaderCell>
                            <Table.HeaderCell className="tableCellWidth">
                                <HeaderText text={"Exp Notes"} />
                            </Table.HeaderCell>

                            <Table.HeaderCell className="tableCellWidth">
                                <HeaderText text={"Status Code"} />
                                <Search className="statusCodeHeader" onSearchChange={props.onTimecardStatusCodeSearch}
                                    placeholder={Constants.SEARCH_PLACEHOLDER} />
                            </Table.HeaderCell>

                            <Table.HeaderCell className="tableCellWidth">
                                <HeaderText text={"Synced Date Time"} />
                                <MuiPickersUtilsProvider utils={DateFnsUtils} >
                                    <KeyboardDatePicker className="date-field"
                                        disabled={!props.timeCard.isInputEnabled}
                                        placeholder="MM/DD/YY"
                                        clearable
                                        value={props.timeCard && props.timeCard.selectedSyncDate ? props.timeCard.selectedSyncDate : null}
                                        onChange={date => props.handleSyncDateChange(date)}
                                        inputProps={{ readOnly: true }}
                                        format="MM/dd/yy"
                                        inputVariant="outlined"
                                        {...(props.timeCard.minimumDate ? { minDate: props.timeCard.minimumDate } : {})}
                                        {...(props.timeCard.maximumDate ? { maxDate: props.timeCard.maximumDate } : {})}
                                    />
                                </MuiPickersUtilsProvider>
                            </Table.HeaderCell>
                            <Table.HeaderCell className="tableCellWidth">
                                <HeaderText text={"Week Ending Date"} />
                                <MuiPickersUtilsProvider utils={DateFnsUtils} >
                                    <KeyboardDatePicker className="date-field_1"
                                        disabled={!props.timeCard.isInputEnabled}
                                        placeholder="MM/DD/YY"
                                        clearable
                                        value={props.timeCard && props.timeCard.selectedWeekEndingDate ? props.timeCard.selectedWeekEndingDate : null}
                                        onChange={date => props.handleWeekEndingDateChange(date)}
                                        inputProps={{ readOnly: true }}
                                        format="MM/dd/yy"
                                        inputVariant="outlined"
                                        {...(props.timeCard.minimumDate ? { minDate: props.timeCard.minimumDate } : {})}
                                        {...(props.timeCard.maximumDate ? { maxDate: props.timeCard.maximumDate } : {})}
                                    />
                                </MuiPickersUtilsProvider>
                            </Table.HeaderCell>
                            <Table.HeaderCell className="tableCellWidth">
                                <HeaderText text={"Integration Status"} />
                            </Table.HeaderCell>
                        </Table.Row>
                    </Table.Header>
                    {props.timeCard.timeRecords && props.timeCard.timeRecords.length > 0 ? props.timeCard.timeRecords.map(({ fullName, hoursType, hours, employeeNumber, deviceEmpID, taskName, taskNumber, projectNumber, jobOverride, unionOverride, day, timeRecordID, expectationUnits, workUnits, deviceID, workDoneAtJobSite, weekEndingDate, userSyncOnlineDateTime, submittedDeviceName, payrollNote, workNote, expectationNote, isTimeRecordIdExist, isAttachmentAdded, intStatus, fieldStatusDescription, startTime, endTime, lunchStartTime, lunchEndTime, attestationStatus }, index) => (
                        <Table.Body className="body-bg" key={`${timeRecordID}${deviceID}${index}`}>
                            <Table.Row className="dataColumn">
                                <Table.Cell className={payrollNote !== null ? "highlightNotes" : "text-center"}>
                                    <div className="d-flex justify-content-center" onClick={() => {
                                        props.openNotes({ modalOpenPayRollNote: true, timeCardId: timeRecordID, deviceId: deviceID });
                                    }}>
                                        <span className="iconify myiconstyle pointerCurser" data-icon="mdi-file-edit-outline" data-inline="false" ></span>
                                    </div>
                                    {/* <Icon className="myiconstyle pointerCurser" edit name='file edit pencil outline' onClick={() => {
                                        props.openNotes({ modalOpenPayRollNote: true, timeCardId: timeRecordID });
                                    }} /> */}
                                </Table.Cell>
                                <Table.Cell className="text-nowrap">{employeeNumber}-{fullName}</Table.Cell>
                                <Table.Cell className="text-nowrap">{submittedDeviceName != null ? submittedDeviceName : deviceEmpID}</Table.Cell>
                                <Table.Cell >{projectNumber}</Table.Cell>
                                <Table.Cell >{taskNumber}</Table.Cell>
                                <Table.Cell className="tableCellWidth">{hoursType}</Table.Cell>
                                <Table.Cell className="tableCellWidth">{isNaN(parseFloat(hours)) ? "" : parseFloat(hours)}</Table.Cell>
                                <Table.Cell className="tableCellWidth">{startTime != null ? startTime : ""}</Table.Cell>
                                <Table.Cell className="tableCellWidth">{lunchStartTime != null ? lunchStartTime : ""}</Table.Cell>
                                <Table.Cell className="tableCellWidth">{lunchEndTime != null ? lunchEndTime : ""}</Table.Cell>
                                <Table.Cell className="tableCellWidth">{endTime != null ? endTime : ""}</Table.Cell>
                                <Table.Cell className="text-nowrap">
                                    <div className="d-flex justify-content-center">
                                        <div className="d-flex justify-content-center" style={{ width: '20px', height: '20px', backgroundColor: getAttestationIconColor(attestationStatus), alignItems: 'center' }} onClick={() => attestationStatus && props.onOpenOrCloseAttestationModal(true, timeRecordID, deviceID)}>
                                            <span style={{ color: 'white' }} className={`iconify ${attestationStatus ? 'pointerCurser' : ''}`} data-icon="mdi:eye-outline" data-inline="false" ></span>
                                        </div>
                                    </div>
                                </Table.Cell>
                                <Table.Cell className="tableCellWidth">{isNaN(parseFloat(workUnits)) ? "" : (parseFloat(workUnits) > 0 ? parseFloat(workUnits) : "")}</Table.Cell>
                                <Table.Cell className={(workNote !== null || isAttachmentAdded) && !isTimeRecordIdExist ? "highlightNotes text-center" : "text-center"}>
                                    {!isTimeRecordIdExist ?

                                        <div className="d-flex justify-content-center" onClick={() => {
                                            props.openNotes({ modalOpenActualNote: true, timeCardId: timeRecordID, deviceId: deviceID });
                                        }}>
                                            <span className="iconify myiconstyle pointerCurser" data-icon="mdi-file-edit-outline" data-inline="false" ></span>
                                        </div>
                                        : ""}
                                </Table.Cell>
                                <Table.Cell className="tableCellWidth">{(workDoneAtJobSite == 'true' || workDoneAtJobSite == 'Yes') ? 'Yes' : 'No'}</Table.Cell>
                                <Table.Cell className="tableCellWidth">{jobOverride}</Table.Cell>
                                <Table.Cell className="tableCellWidth">{unionOverride}</Table.Cell>
                                <Table.Cell className="tableCellWidth">{day}</Table.Cell>
                                <Table.Cell className="tableCellWidth">{isNaN(parseFloat(expectationUnits)) ? "" : (parseFloat(expectationUnits) > 0 ? parseFloat(expectationUnits) : "")}</Table.Cell>
                                <Table.Cell className={expectationNote !== null && !isTimeRecordIdExist ? "highlightNotes text-center" : "text-center"}>
                                    {!isTimeRecordIdExist ?

                                        <div className="d-flex justify-content-center" onClick={() => {
                                            props.openNotes({ modalOpenExceptationalNote: true, timeCardId: timeRecordID, deviceId: deviceID });
                                        }}>
                                            <span className="iconify myiconstyle pointerCurser" data-icon="mdi-file-edit-outline" data-inline="false" ></span>
                                        </div>
                                        : ""}
                                </Table.Cell>
                                <Table.Cell className="tableCellWidth">{fieldStatusDescription}</Table.Cell>
                                <Table.Cell className="tableCellWidth" style={{ textTransform: 'uppercase' }}>{moment(new Date(`${userSyncOnlineDateTime}Z`)).format("MM/DD/YY hh:mm a")}</Table.Cell>
                                <Table.Cell className="tableCellWidth">{weekEndingDate}</Table.Cell>
                                <Table.Cell className="text-center">
                                    {PROCESSED_AND_EXPORTED_STATUS_LIST.includes(intStatus?.toLowerCase() ?? "")
                                        ?
                                        <Icon style={{ color: "green" }} name="check"></Icon>
                                        :
                                        (
                                            (NEW_STATUS_LIST.includes(intStatus?.toLowerCase() ?? ""))
                                                ?
                                                <Icon name="hourglass outline"></Icon>
                                                :
                                                ""
                                        )
                                    }
                                </Table.Cell>
                            </Table.Row>
                        </Table.Body>)) :
                        <Table.Row style={{ width: '100%' }}>
                            <Table.Cell colSpan="24">
                                <NoResultFound displayMessage={Constants.NO_RESULT_FOUND} />
                            </Table.Cell>
                        </Table.Row>
                    }
                </Table>
            </div>
            {
                props.timeCard.timeRecords && props.timeCard.timeRecords.length > 0 &&
                <Pagination floated="right"
                    activePage={props.timeCard.pagination.activePage}
                    onPageChange={props.paginationChange}
                    ellipsisItem={null}
                    firstItem={null}
                    lastItem={null}
                    totalPages={props.timeCard.pagination.totalCount} />
            }
            {props.timeCard.isIssueClicked && <TimeCardIssue closeIssue={props.closeIssueNotes} isCheckedArchive={props.timeCard.isCheckedArchive} lastArchiveDate={props.timeCard.lastArchiveDate} maximumDate={props.timeCard.maximumDate} minimumDate={props.timeCard.minimumDate} />}
            {props.timeCard.isDailyDetailsClicked && <TimeCardDailyDetails closeDailyDetails={props.closeDailyDetailsNotes} isCheckedArchive={props.timeCard.isCheckedArchive} lastArchiveDate={props.timeCard.lastArchiveDate} maximumDate={props.timeCard.maximumDate} minimumDate={props.timeCard.minimumDate} />}
            <Modal closeIcon
                open={props.timeCard.isOpenPayRollNotes}
                closeOnDimmerClick={false}
                size='tiny'
                onClose={() => props.openNotes({
                    modalOpenPayRollNote: false,
                    timeCardId: props.timeCard.selectedNotes ? props.timeCard.selectedNotes.timeRecordID : "",
                    deviceId: props.timeCard.selectedNotes ? props.timeCard.selectedNotes.deviceID : ""
                })}
            >
                <Modal.Header className="headerColor text-color">Payroll Note</Modal.Header>
                <Modal.Content scrolling style={{ minHeight: "auto" }}>
                    <p>{props.timeCard.selectedNotes.payrollNote}</p>
                </Modal.Content>
                <Modal.Actions>
                    <Button primary onClick={() => props.openNotes({
                        modalOpenPayRollNote: false,
                        timeCardId: props.timeCard.selectedNotes ? props.timeCard.selectedNotes.timeRecordID : "",
                        deviceId: props.timeCard.selectedNotes ? props.timeCard.selectedNotes.deviceID : ""
                    })}>
                        Ok
                    </Button>
                </Modal.Actions>
            </Modal>
            <Modal closeIcon
                open={props.timeCard.isOpenActualNotes}
                closeOnDimmerClick={false}
                size='tiny'
                onClose={() => props.openNotes({
                    modalOpenActualNote: false,
                    timeCardId: props.timeCard.selectedNotes ? props.timeCard.selectedNotes.timeRecordID : "",
                    deviceId: props.timeCard.selectedNotes ? props.timeCard.selectedNotes.deviceID : ""
                })}
            >
                <Modal.Header className="headerColor text-color">Actual Work Notes</Modal.Header>
                <Modal.Content scrolling style={{ minHeight: "auto" }}>
                    {props.timeCard.isShowActualModalLoading ? <p style={{ textAlign: "center" }}>Loading...</p> :
                        <div>
                            <h4>{props.timeCard.selectedNotes.workNote}</h4>
                            <h5 className="timecardAttachment">Attachments
                                {/* {(props.timeCard.selectedNotes.attachments && props.timeCard.selectedNotes.attachments.length > 0) && <Button onClick={props.onClickPrint} primary>Print</Button>} */}
                                <a class="ui teal tiny label">{props.timeCard.selectedNotes.attachments && props.timeCard.selectedNotes.attachments.length}</a>
                            </h5>
                            {props.timeCard.selectedNotes.attachments && props.timeCard.selectedNotes.attachments.length > 0 && props.timeCard.selectedNotes.attachments.map(attach => {
                                return (<img style={{ width: '50px', height: '50px', marginLeft: '5px' }} alt={attach.attachmentName} src={Constants.DATA_BASE64 + attach.attachmentContent} onClick={() => props.openAttachmentViewer(attach)} />)
                            })}
                        </div>
                    }
                </Modal.Content>
                <Modal.Actions>
                    {(props.timeCard.selectedNotes.attachments && props.timeCard.selectedNotes.attachments.length > 0) && <Button onClick={props.onClickPrint} primary>Print</Button>}
                    <Button secondary onClick={() => props.openNotes({
                        modalOpenActualNote: false,
                        timeCardId: props.timeCard.selectedNotes ? props.timeCard.selectedNotes.timeRecordID : "",
                        deviceId: props.timeCard.selectedNotes ? props.timeCard.selectedNotes.deviceID : ""
                    })}>
                        Back
                    </Button>
                </Modal.Actions>
            </Modal>
            <Modal closeIcon
                open={props.timeCard.isOpenExceptationalNotes}
                closeOnDimmerClick={false}
                size='tiny'
                onClose={() => props.openNotes({
                    modalOpenExceptationalNote: false,
                    timeCardId: props.timeCard.selectedNotes ? props.timeCard.selectedNotes.timeRecordID : "",
                    deviceId: props.timeCard.selectedNotes ? props.timeCard.selectedNotes.deviceID : ""
                })}
            >
                <Modal.Header className="headerColor text-color">Expectation Work Notes</Modal.Header>
                <Modal.Content scrolling style={{ minHeight: "auto" }}>
                    <p>{props.timeCard.selectedNotes.expectationNote}</p>
                </Modal.Content>
                <Modal.Actions>
                    <Button primary onClick={() => props.openNotes({
                        modalOpenExceptationalNote: false,
                        timeCardId: props.timeCard.selectedNotes ? props.timeCard.selectedNotes.timeRecordID : "",
                        deviceId: props.timeCard.selectedNotes ? props.timeCard.selectedNotes.deviceID : ""
                    })}>
                        Ok
                    </Button>
                </Modal.Actions>
            </Modal>

            {
                props.timeCard.isShowAttestationModal &&
                <AttestationModal
                    attestationPDF={props.timeCard.selectedAttestationPDF}
                    isShowAttestationModal={props.timeCard.isShowAttestationModal}
                    onOpenOrCloseAttestationModal={props.onOpenOrCloseAttestationModal}
                />
            }

            {
                props.timeCard.isAttachmentModelVisible &&
                <AttachmentViewer attachmentName={props.timeCard.selectedAttachment.attachmentName} attachmentContent={props.timeCard.selectedAttachment.attachmentContent} closeAttachmentViewer={props.closeAttachmentViewer} />
            }

            <Modal closeIcon
                open={props.timeCard.isShowArchiveModal}
                onClose={() => props.showArchiveModal(false)}
                style={{ width: '300px', maxWidth: '90%' }}
            >
                <Modal.Header className="headerColor text-color">Archive</Modal.Header>
                <Modal.Content scrolling>
                    <Form>
                        <Form.Group inline widths='equal'>
                            <Form.Field>
                                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                    <KeyboardDatePicker className="issue-field"
                                        placeholder="MM/dd/yyyy"
                                        value={props.timeCard.selectedLastArchiveDate ? new Date(props.timeCard.selectedLastArchiveDate) : null}
                                        onChange={date => props.handleDateChange(date, true)}
                                        inputProps={{ readOnly: true }}
                                        format="MM/dd/yyyy"
                                        label="LastArchive Date:"
                                        name="employeeHireDate"
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                    />
                                </MuiPickersUtilsProvider>
                            </Form.Field>
                        </Form.Group>
                    </Form>
                </Modal.Content>
                <Modal.Actions>
                    <Button primary onClick={() => props.submitArchieveProcess()}>Start </Button>
                    <Button secondary onClick={() => props.showArchiveModal(false)}>Back</Button>
                </Modal.Actions>
            </Modal>

        </Layout >
    );
}

export default TimeCardComponent;

TimeCardComponent.displayName = "TimeCardComponent";